import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Header from '@/components/Header';
import { Footer } from '@/components/Footer';
import FooterMenu from '@/components/FooterMenu';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { Toaster } from '@/components/ui/toaster';

import { ExtranetRoutes } from './Extranet';

const Root = () => {
  const params = useParams();
  const { parametroDaRota } = params;
  // console.log(parametroDaRota);
  let tituloBreadcrumbs = "extranet";
  if (parametroDaRota) {
    tituloBreadcrumbs += `/${parametroDaRota}`;
  }
  // console.log(tituloBreadcrumbs);

  return (
    <Router>
      <Header />
      <div className="container">
        <main id="main-wrapper">
          <Breadcrumbs title={tituloBreadcrumbs} icon="fa fa-home" subTitle="" />
          <Toaster />

          <Routes>
            <Route path='/extranet/*' element={<ExtranetRoutes />} />
          </Routes>
          
        </main>
      </div>
      <FooterMenu />
      <Footer />
    </Router>
  );
};

export default Root;